import React from "react";

import ShareIcon from "../Icons/ShareIcon";

const ShareButton = ({ handleDisplayShare }) => {
  const handleClick = () => {
    handleDisplayShare();
  };

  return (
    <li
      className="navigation__item navigation__item--extra navigation__item--share"
      onClick={handleClick}
    >
      <div className="navigation__icon">
        <ShareIcon />
      </div>
      <span className="navigation__action__text">Share</span>
    </li>
  );
};

export default ShareButton;
